// src/utils/authHelper.js
export function getAuthToken() {
  return localStorage.getItem('teacherToken') || localStorage.getItem('token') || null;
}

export function getAuthHeader() {
  const t = getAuthToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}